<template>
  <section class="bg">
    <header-tab :tabs="tags" :activity="proData.tag" @onTab="onTab" tabDisplayName="Name">
    </header-tab>
    <div>
      <ul class="study-list" v-infinite-scroll="getProList" infinite-scroll-disabled="loading"
        infinite-scroll-distance="60">
        <li v-for="item in proList" :key="item.ID">
          <router-link :to="{name: 'shop-detail',params: {id:item.ID}}">
            <div class="img">
              <img class="img"
                :src="item.TitleImagePath !=null?item.TitleImagePath +'?x-oss-process=image/resize,m_fill,h_172,w_172':defaultImg+'?x-oss-process=image/resize,m_fill,h_172,w_172'"
                :onerror="defaultImg+'?x-oss-process=image/resize,m_fill,h_172,w_172'" alt>
            </div>
            <div class="title" style="-webkit-box-orient: vertical;">{{item.Title}}</div>
            <div class="label clearfix">
              <span v-for="(tag,i) in splitTags(item.Tags)" :key="i">{{tag}}</span>
            </div>
          </router-link>
        </li>
      </ul>
      <Empty v-if="isEmpty"></Empty>
      <div class="status-hint" v-show="pageHint">{{pageHint}}</div>
      <footer-logo></footer-logo>
      <footer-nav :name="name"></footer-nav>
    </div>
  </section>
</template>

<script>
  import Utility from '@/helper/util.js'
  import footerNav from '@/views/footerNav.vue'
  import footerLogo from '@/components/footerLogo.vue'
  import Empty from '@/views/statePage/empty.vue'
  import HeaderTab from '@/components/HeaderTab.vue'

  export default {
    components: {
      Empty,
      HeaderTab,
      'footer-nav': footerNav,
      'footer-logo': footerLogo
    },
    data() {
      return {
        pageHint: '',
        isEmpty: false,
        loading: false,
        proList: [],
        proData: {
          pageIndex: 1,
          pageSize: 10,
          tag: '',
          category: ''
        },
        name: {
          name: '战疫产品'
        },
        tags: [],
        totalPage: -1,
        path: this.$route.path,
        defaultImg: 'http://image.gongyi.la/org/1/album/2018/09/01d34f33d65440c58d11d1802f3c1cc7.png'
      }
    },
    created() {
      this.proData.tag = this.$route.query.tag
      if (!this.proData.tag) this.proData.tag = ''

      this.getTags().then(() => {
        this.getProList()
      })
    },
    methods: {
      onTab(tag) {
        this.proData.category = tag.Id
        this.proData.pageIndex = 1
        this.proList = []
        this.getProList()
      },
      getTags() {
        // return new Promise((resolve, reject) => {
        //   this.$fetch('/api/Product/GetAllTags', {}).then(result => {
        //     this.tags = result
        //     resolve()
        //   })
        // })
        return new Promise((resolve, reject) => {
          this.$fetch('/api/Common/GetDicList?value=ProductType', {}).then(result => {
            this.tags = result
            resolve()
          })
        })
      },
      splitTags(tags) {
        return Utility.splitTags(tags)
      },
      getProList() {
        if (!this.tags || !this.tags.length) {
          return
        }
        if (this.totalPage > -1 && this.proData.pageIndex > this.totalPage) {
          this.loading = false
        } else {
          this.loading = true
          this.pageHint = '加载中...'
          var _this = this
          this.$fetch('/api/Product/GetProductList', this.proData).then(result => {
            this.isLoading = false
            this.loading = false
            _this.totalPage = result.PageCount
            if (this.proData.pageIndex >= this.totalPage) {
              this.pageHint = '没有更多了'
            } else {
              this.pageHint = '上拉加载更多'
            }

            if (result.Items && result.Items.length > 0) {
              this.proList = this.proList.concat(result.Items)
              this.isEmpty = false
            } else {
              this.isEmpty = true
              this.pageHint = ''
            }
            this.proData.pageIndex++
          })
        }
      }
    }
  }

</script>
<style lang="less" scoped>
  .bg {
    background: #f7f7f7;
    min-height: 100%;
  }

  .tab {
    width: 100%;
    height: 100 / @rem-size;
    border-bottom: 1px solid #e5e5e5;
    background: #fff;

    li {
      width: 50%;
      float: left;
      line-height: 100 / @rem-size;
      text-align: center;
      font-size: 32 / @rem-size;
      color: #333;
      position: relative;

      a {
        color: #333;
      }

      &.active {
        a {
          color: #005fd5;
        }

        &::after {
          display: block;
          content: '';
          width: 120 / @rem-size;
          height: 2 / @rem-size;
          background: #005fd5;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
      }
    }
  }

  .study-list {
    width: 100%;
    height: auto;
    padding: 0 24 / @rem-size 24 / @rem-size;
    background: #fff;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-bottom: 10 / @rem-size solid #f7f7f7;

    li {
      width: 345 / @rem-size;
      margin-top: 24 / @rem-size;
      overflow: hidden;

      &:active {
        .img {
          opacity: 0.8;
        }
      }

      .img {
        width: 345 / @rem-size;
        height: 345 / @rem-size;
        overflow: hidden;
      }

      .title {
        font-size: 30 / @rem-size;
        line-height: 45 / @rem-size;
        margin-top: 10 / @rem-size;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }

  .label {
    width: 100%;
    height: 70 / @rem-size;
    overflow: hidden;

    span {
      display: block;
      padding: 8 / @rem-size 18 / @rem-size;
      float: left;
      font-size: 24 / @rem-size;
      color: #999;
      border: 1px solid #e5e5e5;
      border-radius: 5 / @rem-size;
      margin-right: 14 / @rem-size;
      margin-top: 14 / @rem-size;
    }
  }

</style>
